export const MIN_ITEM_WIDTH = 230;

export const MIN_MOBILE_WIDTH = 180;

export const MIN_COLUMNS = 3;

export const MIN_MOBILE_COLUMNS = 2;

export const MAX_COLUMNS = 5;

export const X_CARDS_MOBILE_MARGIN = 4;

export const X_CARDS_MARGIN = 8;

export const THROTTLE_TIMEOUT = 200;
